'use es6';

import actionTypes from 'ContentEditorUI/redux/actions/inpageActionTypes';

// Note, these are not treated as real Redux actions. They are structured like actions,
// but they will be received as post message events in the parent.
// More info in inpageActionTypes.js

export const addModuleToFlexColumnFromInpageSidebar = message => {
  return {
    type: actionTypes.ADD_MODULE_TO_FLEX_COLUMN_FROM_INPAGE_SIDEBAR,
    message
  };
};
export const addModuleToLayoutSectionFromInpageSidebar = message => {
  return {
    type: actionTypes.ADD_MODULE_TO_LAYOUT_SECTION_FROM_INPAGE_SIDEBAR,
    message
  };
};
export const moduleHtmlRequested = (moduleName, moduleVersion, {
  refreshOnFail = false,
  smartRuleModuleBody
} = {}) => {
  return {
    type: actionTypes.MODULE_HTML_REQUESTED,
    message: {
      moduleName,
      moduleVersion,
      refreshOnFail,
      smartRuleModuleBody
    }
  };
};
export const sectionHtmlRequested = (sectionName, sectionVersion) => {
  return {
    type: actionTypes.SECTION_HTML_REQUESTED,
    message: {
      sectionName,
      sectionVersion
    }
  };
};
export const saveAndTriggerRefresh = () => {
  return {
    type: actionTypes.SAVE_AND_REFRESH_PREVIEW
  };
};